import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import { AdminAuthProvider } from "./lib/auth";

// Storefront
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import ThankYou from "./pages/ThankYou";
import Wishlist from "./pages/Wishlist";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";
import { ContentProvider } from "./lib/content";

// Admin
import AdminLayout from "./components/admin/AdminLayout";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminProducts from "./pages/admin/Products";
import AdminCategories from "./pages/admin/Categories";
import AdminOrders, { AdminOrderDetail } from "./pages/admin/Orders";
import AdminCustomers from "./pages/admin/Customers";
import AdminSettings from "./pages/admin/Settings";
import AdminReports from "./pages/admin/Reports";
import AdminSubmissions from "./pages/admin/Submissions";
import AdminContent from "./pages/admin/Content";
import AdminAccount from "./pages/admin/Account";
import AdminCoupons from "./pages/admin/Coupons";
import AdminReviews from "./pages/admin/Reviews";
import AdminAbandonedCarts from "./pages/admin/AbandonedCarts";

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <CartProvider>
          <WishlistProvider>
            <ContentProvider>
            <BrowserRouter>
              <Routes>
                {/* Storefront */}
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/thank-you" element={<ThankYou />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/legal/:slug" element={<Legal />} />
                  <Route path="*" element={<NotFound />} />
                </Route>

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="categories" element={<AdminCategories />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="orders/:id" element={<AdminOrderDetail />} />
                  <Route path="customers" element={<AdminCustomers />} />
                  <Route path="coupons" element={<AdminCoupons />} />
                  <Route path="reviews" element={<AdminReviews />} />
                  <Route path="abandoned-carts" element={<AdminAbandonedCarts />} />
                  <Route path="submissions" element={<AdminSubmissions />} />
                  <Route path="content" element={<AdminContent />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="reports" element={<AdminReports />} />
                  <Route path="account" element={<AdminAccount />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
          </ContentProvider>
          </WishlistProvider>
        </CartProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
